module.exports = __webpack_public_path__ + "static/media/entertainment.faacc042.jpg";